import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FromToFilter, useSensorHistory } from "../../../api";
import { BaseCard } from "../../BaseCard";
import { BeaconAccelerometerDrawer } from "./AccelerometerDrawer";
import { AccelerometerTable } from "./AccelerometerTable";

interface BeaconAccelerometerCardProps {
  serial: string;
  selectedFromToFilter:
    | (FromToFilter & number)
    | (FromToFilter & {
        from: Date;
        to: Date;
      });
}

export function BeaconAccelerometerCard({
  serial,
  selectedFromToFilter,
}: BeaconAccelerometerCardProps) {
  const { t } = useTranslation();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const sensorHistory = useSensorHistory(serial, selectedFromToFilter);

  return (
    <BaseCard title={t("accelerometer")} allowScroll={true}>
      <AccelerometerTable
        sensorData={sensorHistory}
        axisPercision={3}
        axisColumnWidth={100}
      />
      <BeaconAccelerometerDrawer
        sensorData={sensorHistory}
        drawerVisible={drawerVisible}
        onCloseDrawer={() => setDrawerVisible(false)}
      />
      <Button
        aria-label="show-drawer-button"
        className="show-card-drawer-button"
        type="primary"
        onClick={() => setDrawerVisible(true)}
        icon={<PlusOutlined />}
      />
    </BaseCard>
  );
}
